/**
 * Created by user on 2018/4/15/015.
 */

import { charTableList as char_table, textList as text_list, arrCjk as arr_cjk } from '@lazy-cjk/zh-table-list/list';

export { char_table, text_list, arr_cjk }
